<div
class="view-undo"
*ngIf="(canUndo$ | async)"
@show>
    <app-pillbox padding="dense">
        <button 
        (click)="handleUndoClick()"
        app-pin-button
        data-test="undo-btn"
        [attr.aria-disabled]="!(canUndo$ | async)"
        [disabled]="!(canUndo$ | async)"
        buttonType="ghost"
        class="mr-2"
        icon="undo"
        aria-label="Undo"
        matTooltip="Undo"
        ></button>
        
        <button
        buttonType="ghost"
        app-pin-button
        class="mr-2"
        data-test="redo-btn"
        [attr.aria-disabled]="!(canRedo$ | async)"
        [disabled]="!(canRedo$ | async)"
        aria-label="Redo"
        matTooltip="Redo"
        icon="redo"
        (click)="handleRedoClick()">
        </button>

        <button
        app-pin-button
        buttonType="ghost"
        [attr.aria-disabled]="!(canUndo$ | async)"
        [disabled]="!(canUndo$ | async)"
        (click)="handleResetClick()">
        <span class="ph-4 text-bold">Reset</span>
        </button>
    </app-pillbox>
</div>
